import { FilterLiveForm, useListContext } from "ra-core";
import { useState } from "react";
import { SearchInput, type SearchInputProps } from "@/components/admin";
import { useIsMobile } from "@/hooks/use-mobile";
import {
  MobileFilterButton,
  MobileFilterPanel,
} from "../layout/MobileFilterPanel";
export const ResponsiveFilters = ({
  children,
  searchInput,
  filtersLabel = "Фильтры контактов",
}: {
  children: React.ReactNode;
  searchInput?: Partial<SearchInputProps>;
  filtersLabel?: string;
}) => {
  const { source = "q", ...searchProps } = searchInput ?? {};
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);
  const { setFilters, filterValues } = useListContext();
  const count = Object.keys(filterValues ?? {}).filter(
    (key) => key !== source,
  ).length;
  if (isMobile)
    return (
      <>
        <MobileFilterButton
          label={filtersLabel}
          count={count}
          onClick={() => setOpen(true)}
        />
        <MobileFilterPanel
          title={filtersLabel}
          open={open}
          onOpenChange={setOpen}
          onReset={() =>
            setFilters(
              filterValues[source] ? { [source]: filterValues[source] } : {},
              [],
            )
          }
        >
          {children}
        </MobileFilterPanel>
      </>
    );
  return (
    <div className="w-52 min-w-52 order-first pt-0.75 flex flex-col gap-4">
      <FilterLiveForm>
        <SearchInput source={source} {...searchProps} />
      </FilterLiveForm>
      {children}
    </div>
  );
};
